// axios
import axios from 'axios'

const axiosIns = axios.create({
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
})

export default axiosIns
